"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var core_1 = require("@material-ui/core");

var Clear_1 = require("@material-ui/icons/Clear");

var react_1 = require("react");

var PantVersions = function PantVersions(props) {
  var _a = props.appState,
      versState = _a.versState,
      pantState = _a.pantState;
  var theme = core_1.useTheme();
  var marginTop = pantState.headerHeight || 64;
  var fullScreen = core_1.useMediaQuery(theme.breakpoints.down('xs'));
  var dialogStyle = !fullScreen ? {
    marginTop: marginTop
  } : {};
  var titleStyle = !fullScreen ? {} : {
    marginTop: marginTop
  };
  var iconCloseStyle = !fullScreen ? {
    position: 'absolute',
    top: 8,
    right: 8
  } : {
    position: 'absolute',
    top: 8 + marginTop,
    right: 8
  };
  react_1.useEffect(function () {
    versState.viewed();
    versState.load();
  }, []);

  var handleClose = function handleClose() {
    pantState.goBack();
  };

  var close = React.createElement(core_1.IconButton, {
    style: iconCloseStyle,
    onClick: handleClose
  }, React.createElement(Clear_1.default, {
    color: "disabled"
  }));
  var title = React.createElement("div", {
    style: titleStyle
  }, React.createElement(core_1.Typography, {
    variant: "h6"
  }, "Versions"), close);
  return React.createElement(core_1.Dialog, {
    open: true,
    onClose: handleClose,
    scroll: "paper",
    maxWidth: "md",
    fullWidth: true,
    style: dialogStyle,
    fullScreen: fullScreen
  }, React.createElement(core_1.DialogTitle, {
    disableTypography: true
  }, title), React.createElement(core_1.DialogContent, {
    dividers: true
  }, React.createElement(core_1.List, null, versState.versions.map(function (v, i) {
    return React.createElement(core_1.ListItem, {
      key: i
    }, React.createElement(core_1.ListItemText, {
      style: {
        fontWeight: 'bold',
        top: 16,
        width: 100
      },
      primary: v.versio && 'v.' + v.versio
    }), React.createElement(core_1.ListItemText, {
      style: {
        paddingLeft: 20,
        top: 16,
        width: '100%'
      },
      primary: v.missatge,
      secondary: v.data
    }));
  }))), React.createElement(core_1.DialogActions, null, React.createElement(core_1.Button, {
    onClick: handleClose
  }, "Tancar")));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(PantVersions));